const getPrecisionSelectOptions = (pricePrecision) => {
  return Array.from({ length: 4 }, (_, i) => {
    return Number(
      (Math.pow(10, -pricePrecision) * Math.pow(10, i)).toFixed(pricePrecision)
    )
  })
}

export default getPrecisionSelectOptions
